
import React, { forwardRef, useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { formatOccupantsAsGuests } from 'lib/occupancyUtils'
import { validateOccupants } from 'lib/flights'

import Clickable from 'components/Common/Clickable'
import { AutoTooltipContent } from 'components/Common/AutoTooltip'
import HighlightBorder from 'components/Common/HighlightBorder'
import cn from 'clsx'
import Breakpoint from 'components/Common/Breakpoint'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Caption from 'components/Luxkit/Typography/Caption'

const Root = styled(Clickable)`
  display: flex;
  border: 1px solid ${props => props.theme.palette.neutral.five};
  padding: 0 ${rem(16)};
  justify-content: flex-start;
  align-items: center;
  height: ${rem(48)};
  border-radius: ${props => props.theme.borderRadius.small};
  width: 100%;
  flex: 1;
  position: relative;
  background: ${props => props.theme.palette.neutral.eight};

  &.error {
    background: ${props => props.theme.palette.messaging.critical.light};
    border: none;
  }
`

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;
`

const StyledTooltipContent = styled(AutoTooltipContent)`
  width: max-content;
`

interface Props {
  occupants: App.Occupants;
  handleOpen: () => void;
}
const StyledHighlightBorder = styled(HighlightBorder)`
  box-shadow: inset 0 0 0 1px;

  &.has-error {
    color: ${props => props.theme.palette.messaging.critical.main};
  }
`

const TravellerInputToogle = forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const { occupants, handleOpen } = props
  const travellerLabel = useMemo(() => formatOccupantsAsGuests(occupants), [occupants])
  const errorMessage = "Please select children's ages"

  const showAgesError = useMemo(() => occupants.children && occupants.childrenAge?.some(age => age === -1), [occupants])
  const invalidSelection = useMemo(() => validateOccupants(occupants), [occupants])

  return (
    <Root ref={ref} onClick={handleOpen} className={cn({ error: showAgesError || invalidSelection })} data-testid="traveller-input-toggle">
      <StyledHighlightBorder
        visible={showAgesError || invalidSelection}
        className={cn({ 'has-error': showAgesError || invalidSelection })}
      />
      <InputWrapper>
        <Caption variant="large" weight="bold">Travellers</Caption>
        <BodyText variant="medium">{travellerLabel}</BodyText>
      </InputWrapper>
      <Breakpoint min="lg">
        <StyledTooltipContent
        open={showAgesError}
        position="above-left"

        alignment="left"
        type="error"
      >
          {errorMessage}
        </StyledTooltipContent>
      </Breakpoint>
    </Root>
  )
})

export default TravellerInputToogle
